export const YOUTUBE_BETA_BANNER_COPY = {
  headline: 'YouTube is on for your account.',
  body: 'Connect your YouTube channel to add YouTube live chat to your chat overlays.',
  link: 'Go to Connections',
  dismiss: 'Dismiss'
} as const

export const youTubeBannerEligible = ({
  entitlementsReady,
  invited,
  closed,
  onConnectionsPage
}: {
  entitlementsReady: boolean
  invited: boolean
  closed: boolean
  onConnectionsPage: boolean
}): boolean => entitlementsReady && invited && !closed && !onConnectionsPage

export const youTubeBannerVisible = (
  eligible: boolean,
  youtubeLinked: boolean | null
): boolean => eligible && youtubeLinked === false

export const YOUTUBE_BETA_BANNER_KEY_PREFIX = 'stream-tools.youtube-beta-banner-closed.v1:'

export const youTubeBannerKey = (accountId: string): string =>
  `${YOUTUBE_BETA_BANNER_KEY_PREFIX}${accountId}`

export interface BannerStorage {
  getItem: (key: string) => string | null
  setItem: (key: string, value: string) => void
}

const defaultStorage = (): BannerStorage => globalThis.localStorage

export const readYouTubeBannerClosed = (
  accountId: string,
  storage: () => BannerStorage = defaultStorage
): boolean => {
  try {
    return storage().getItem(youTubeBannerKey(accountId)) === '1'
  } catch {
    return false
  }
}

export const saveYouTubeBannerClosed = (
  accountId: string,
  storage: () => BannerStorage = defaultStorage
): void => {
  try {
    storage().setItem(youTubeBannerKey(accountId), '1')
  } catch {
  }
}
